import { render } from "./BusTzCaseRecord.vue?vue&type=template&id=90b53bcc&scoped=true"
import script from "./BusTzCaseRecord.vue?vue&type=script&lang=js"
export * from "./BusTzCaseRecord.vue?vue&type=script&lang=js"

import "./BusTzCaseRecord.vue?vue&type=style&index=0&id=90b53bcc&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b53bcc"]])

export default __exports__